import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const MbuReportExcel = async (CsvData: any[], formattedDate: any) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('MBU Report');

    const headers = [
        { header: "Business Unit Name", key: "bussinessUnitName", width: 25 },
        { header: "Project Number", key: "job", width: 15 },
        { header: "Last Name", key: "lastName", width: 20 },
        { header: "City", key: "city", width: 15 },
        { header: "Original Contract Amount", key: "originalContractAmount", width: 25 },
        { header: "Current Contract Amount", key: "currentContractAmount", width: 25 },
        { header: "PCC Addenda Sales", key: "pccAddendaSales", width: 20 },
        { header: "PCC Addenda Cost", key: "pccAddendaCost", width: 20 },
        { header: "Project Status Name", key: "projectStatusName", width: 25 },
        { header: "Status ID", key: "statusId", width: 15 },
        { header: "Actual Permit Rcvd Date", key: "actualPermitRcvdDate", width: 25 },
        { header: "Actual Est. Rcvd Date", key: "actualEstRcvdDate", width: 25 },
        { header: "Job Category", key: "jobCategory", width: 20 }, // ← optional, if applicable
        { header: "Project Manager Name", key: "projectManagerName", width: 25 },
        { header: "Design Architect Name", key: "designArchitectName", width: 25 },
        { header: "Project Designer Name", key: "projectDesignerName", width: 25 },
        { header: "CD Designer Name", key: "cdDesignerName", width: 25 },
        { header: "PCCKB Designer Name", key: "pcckbDesignerName", width: 25 },
        { header: "Estimator Name", key: "estematerName", width: 22 },
        { header: "Lead ID", key: "leadId", width: 15 }, // ← optional, if exists
        { header: "Business Unit ID", key: "businessUnitId", width: 20 },
        { header: "Site ID", key: "lst_SiteId", width: 15 },
        { header: "Region ID", key: "lst_RegionId", width: 15 },
        { header: "Sale Date", key: "saleDate", width: 20 },
        { header: "Ready For PCC", key: "readyForPCC", width: 20 },
        { header: "PCC Sign Off", key: "pccSignOf", width: 20 },
        { header: "Send To Purchase", key: "inPurchasing", width: 20 }
    ];


    worksheet.columns = headers;

    // Add header row with bold styling
    worksheet.getRow(1).font = { bold: true };

    // Add the data rows
    CsvData.forEach((item) => {
        worksheet.addRow(item);
    });

    // Optional: auto-fit height for header row
    worksheet.getRow(1).height = 22;

    // Create file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `MBU_Report_${formattedDate}.xlsx`);
};
